import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const ToolbarContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.toolbarContainer, className)}
    data-testid="toolbar-container"
  />
));

ToolbarContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ToolbarContainer;
